import { DataType } from '@labrav/react-components/lib/@types/types/forms'

export const specifiedDateField = {
  title: 'Specified date',
  humanReadableKey: 'Specified date',
  placeHolder: 'Specified date',
  id: 'agreementStartDate',
  isRequired: true,
  isReadOnly: false,
  isCustom: false,
  dataType: 'date',
}

export const startAwsDateTypeField = {
  title: 'Start date',
  placeHolder: 'Start date',
  humanReadableKey: 'variableStartDate',
  id: 'variableStartDate',
  isReadOnly: false,
  isRequired: true,
  dataType: 'enum' as DataType,
  validationType: undefined,
  isCustom: false,
  options: [
    { label: 'Accepted date', value: 'isAccepted' },
    { label: 'Specified date', value: 'isSpecified' },
  ],
}
